import React from 'react';
import { useSelector } from 'react-redux';

const Conference = (props) =>
{
	const session = useSelector((state:any) => state?.mysession?.session);

	return (

		<iframe
			title='Conference'
			id='conference'
			allow='camera; microphone; fullscreen; speaker; display-capture'
			src={`https://apps.invc.vc/${props.session}?token=${props.token}&projectId=${props.callType === 'video' ? process.env.REACT_APP_VIDEO_ID : process.env.REACT_APP_AUDIO_ID}&uid=${window.btoa(session.userId)}`}
			style={{ height: 'var(--percent100)', width: 'var(--percent100)', border: 0 }}
		/>

	);
};

export default Conference;